/**
 * Front door service
 * The front door service API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { FindBySlugDto } from '../model/findBySlugDto';
// @ts-ignore
import { FindSlotsDto } from '../model/findSlotsDto';
// @ts-ignore
import { FrontDoorQueueStatusDto } from '../model/frontDoorQueueStatusDto';
// @ts-ignore
import { FrontDoorSlotDto } from '../model/frontDoorSlotDto';
// @ts-ignore
import { FrontDoorSlotsDto } from '../model/frontDoorSlotsDto';
// @ts-ignore
import { PatientFrontDoorInfoDto } from '../model/patientFrontDoorInfoDto';
// @ts-ignore
import { ReschedulePatientVisitDto } from '../model/reschedulePatientVisitDto';
// @ts-ignore
import { SelfVisitDto } from '../model/selfVisitDto';
// @ts-ignore
import { VisitPricingDto } from '../model/visitPricingDto';
// @ts-ignore
import { WaitingRoomDto } from '../model/waitingRoomDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class FrontDoorPatientInfoService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * 
   * Endpoint is deprecated. New one is located at: &#x60;/front-door-slots/find-next-slot&#x60;. Find next open slot for this front-door start at given date and look forward up to 30 days. This is only used for tenants where front-door throttling is enabled.
   * @param xTENANTID 
   * @param findSlotsDto 
   * @deprecated
   */
  public async patientFrontDoorInfoControllerFindNextAvailableSlot(xTENANTID: string, findSlotsDto: FindSlotsDto, ): Promise<FrontDoorSlotDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerFindNextAvailableSlot.');
    }
    if (findSlotsDto === null || findSlotsDto === undefined) {
      throw new Error('Required parameter findSlotsDto was null or undefined when calling patientFrontDoorInfoControllerFindNextAvailableSlot.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/find-next-slot`,
        data: findSlotsDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID 
   * @param findBySlugDto 
   */
  public async patientFrontDoorInfoControllerFindOneBySlug(xTENANTID: string, findBySlugDto: FindBySlugDto, ): Promise<PatientFrontDoorInfoDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerFindOneBySlug.');
    }
    if (findBySlugDto === null || findBySlugDto === undefined) {
      throw new Error('Required parameter findBySlugDto was null or undefined when calling patientFrontDoorInfoControllerFindOneBySlug.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/slug`,
        data: findBySlugDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * 
   * Endpoint is deprecated. New one is located at: &#x60;/front-door-slots/slots&#x60;. Get slots for the requested date for this front-door. This is only used for tenants where front-door throttling is enabled.
   * @param xTENANTID 
   * @param findSlotsDto 
   * @deprecated
   */
  public async patientFrontDoorInfoControllerGetFrontDoorSlots(xTENANTID: string, findSlotsDto: FindSlotsDto, ): Promise<FrontDoorSlotsDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerGetFrontDoorSlots.');
    }
    if (findSlotsDto === null || findSlotsDto === undefined) {
      throw new Error('Required parameter findSlotsDto was null or undefined when calling patientFrontDoorInfoControllerGetFrontDoorSlots.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/slots`,
        data: findSlotsDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * 
   * Used by existing patient to get the price of visit
   * @param xTENANTID 
   * @param id 
   */
  public async patientFrontDoorInfoControllerGetVisitPrice(xTENANTID: string, id: string, ): Promise<VisitPricingDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerGetVisitPrice.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling patientFrontDoorInfoControllerGetVisitPrice.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pricing`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * 
   * Used by existing patient to check number of patients that are waiting in queue
   * @param xTENANTID 
   * @param id 
   */
  public async patientFrontDoorInfoControllerQueueStatus(xTENANTID: string, id: string, ): Promise<FrontDoorQueueStatusDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerQueueStatus.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling patientFrontDoorInfoControllerQueueStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/queue-status`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * 
   * Used by existing patient to create WaitingRoom and visit for for provider to see
   * @param xTENANTID 
   * @param id 
   * @param selfVisitDto 
   */
  public async patientFrontDoorInfoControllerRequestSelfVisit(xTENANTID: string, id: string, selfVisitDto: SelfVisitDto, ): Promise<WaitingRoomDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerRequestSelfVisit.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling patientFrontDoorInfoControllerRequestSelfVisit.');
    }
    if (selfVisitDto === null || selfVisitDto === undefined) {
      throw new Error('Required parameter selfVisitDto was null or undefined when calling patientFrontDoorInfoControllerRequestSelfVisit.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/request-self-visit`,
        data: selfVisitDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Reschedules existing appointment
   * Allows patient to change the time of their appointment, or get in line now.
   * @param xTENANTID 
   * @param id The front door identifier.
   * @param reschedulePatientVisitDto 
   * @param xUSERTIMEZONE Patient&#x60;s timezone represented in IANA time zone identifier.
   */
  public async patientFrontDoorInfoControllerReschedule(xTENANTID: string, id: string, reschedulePatientVisitDto: ReschedulePatientVisitDto, xUSERTIMEZONE?: string, ): Promise<WaitingRoomDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling patientFrontDoorInfoControllerReschedule.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling patientFrontDoorInfoControllerReschedule.');
    }
    if (reschedulePatientVisitDto === null || reschedulePatientVisitDto === undefined) {
      throw new Error('Required parameter reschedulePatientVisitDto was null or undefined when calling patientFrontDoorInfoControllerReschedule.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }
    if (xUSERTIMEZONE) {
      localVarHeaders['X-USER-TIMEZONE'] = String(xUSERTIMEZONE);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/front-door/v1/front-door/info/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/reschedule`,
        data: reschedulePatientVisitDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
